export default "__VITE_ASSET__CMq7lP1Z__"